<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="tw-inline-flex"
    viewBox="0 0 16 16"
    :stroke="props.stroke"
    :width="props.width"
    :height="props.height"
  >
    <path
      fill-rule="evenodd"
      d="M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0v-6z"
    />
  </svg>
</template>

<script lang="ts" setup>
export interface IconListProps {
  width?: string;
  height?: string;
  stroke?: string;
}

const props = withDefaults(defineProps<IconListProps>(), {
  width: "16px",
  height: "16px",
  stroke: "2",
});
</script>

<style scoped></style>
